export enum ApplicationStatusEnum {
	INITIALIZING,
	READY,
	LOADING,
	LOADED,
}
